const formatCadence = (value) => {
  if (!value) return '—';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const buildPurchaseConfirmation = ({ subscription, type }) => {
  if (!subscription) return null;
  return {
    title: type === 'activated' ? 'Subscription Activated' : 'Subscription Updated',
    message: type === 'activated'
      ? 'Your new subscription is active and entitlements take effect immediately.'
      : 'Your updated subscription is active and entitlements take effect immediately.',
    planName: subscription.plan_name || '—',
    billingCadence: formatCadence(subscription.billing_cadence),
    effectiveNow: true,
    entitlements: subscription.entitlements || {},
    accountFeatures: subscription.account_features || {},
  };
};

const PURCHASE_CONFIRMATION_KEY = 'finbase.subscription_purchase_confirmation';
const CHECKOUT_IN_PROGRESS_KEY = 'finbase.subscription_checkout_in_progress';

export {
  buildPurchaseConfirmation,
  CHECKOUT_IN_PROGRESS_KEY,
  formatCadence,
  PURCHASE_CONFIRMATION_KEY,
};
